export default __webpack_public_path__ + "static/media/banner_va_2.222f659e.jpg";